import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
import { OperatorKeyPointSkeleton } from './operator-key-point';
function OperatorCardSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-12 shrink-0 rounded-full sm:size-10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader className="gap-0 p-0"><div className="flex items-center gap-2">{t0}<div className="flex flex-col gap-1"><Skeleton className="h-4 w-full max-w-32" /></div></div></CardHeader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4.5 w-full" />;
    t3 = <Skeleton className="h-4.5 w-full max-w-5/6" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card className="gap-4 border-none p-3 shadow-lg">{t1}<CardContent className="flex flex-col gap-4 p-0">{t2}{t3}<div className="flex flex-col gap-2"><div className="grid grid-cols-2 gap-2"><OperatorKeyPointSkeleton /><OperatorKeyPointSkeleton /></div><OperatorKeyPointSkeleton /></div></CardContent><Skeleton className="h-9 w-full rounded-md" /></Card>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { OperatorCardSkeleton };